import React from 'react';
import styles from './AvatarModal.module.scss';
import cx from 'classnames';

const AvatarImagePreview = ({ avatar, onSelect, selected }) => {
    return (
        <div className={cx(styles.avatarImagePreview, { [styles.selected]: selected })} onClick={() => onSelect(avatar.avatar_id)} aria-selected={selected} tabIndex={selected ? 0 : -1}>
            <div className={styles.imageWrapper}>
                <img className={styles.avatarImage} src={avatar.preview_image_url} alt={avatar.name} />
            </div>
            <p className={styles.name}>{avatar.avatar_name.split(' ')[0]}</p>
        </div>
    );
}

export default AvatarImagePreview;